import { Box, BoxProps, Image, Spacer, Text, useWindowDimensions } from '@jfs/ui-new'
import { isIE } from '@jfs/utils'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import { isMobileWidth, isTabletWidth } from '../../util/util'

const LayoutBgImage = ({ data, length = 0 }: any) => {
  const viewPortWidth = useWindowDimensions()
  const { subHeaderSize, subHeaderLineHeight, textSize } = useFontSize()
  const resPadding = usePadding()
  const themedStyle = styles(viewPortWidth, resPadding)
  const isMobile = isMobileWidth(viewPortWidth)
  const isTab = isTabletWidth(viewPortWidth)

  const Component = data.component
  return (
    <Box {...themedStyle.container(length)}>
      {!!data.imageTop && (
        <Image
          source={data.imageTop}
          width={isMobile || isTab ? 48 : 80}
          height={isMobile || isTab ? 48 : 80}
          resizeMode="contain"
        />
      )}
      {!!data.component && <Component width={isMobile || isTab ? 48 : 80} height={isMobile || isTab ? 48 : 80} />}
      <Spacer direction="vertical" size={isMobile ? 22 : 'HUGE'} />
      <Box
        flexDirection={'column'}
        justify={isTab ? 'center' : undefined}
        pr={isTab ? resPadding / 2 : 0}
        f={isTab ? 1 : undefined}
        pl={isTab ? 32 : 0}>
        <Text fontSize={subHeaderSize} color="BLACK" fontFamily="jiotype-bold" lineHeight={subHeaderLineHeight}>
          {data.header}
        </Text>
        {!isTab && <Spacer direction="vertical" size={isMobile ? 8 : 12} />}
        <Box w={isTab ? '100%' : '90%'}>
          <Text fontSize={textSize} lineHeight={isMobile ? 20 : 28} fontFamily="jiotype-medium" color={'PRIMARY_GREY'}>
            {data.subHeader}
          </Text>
        </Box>
      </Box>
    </Box>
  )
}

export const HorizontalLayout = ({ data }: any) => {
  const viewPortWidth = useWindowDimensions()
  const resPadding = usePadding()
  const themedStyle = styles(viewPortWidth, resPadding)

  return (
    <Box {...themedStyle.parentContainer(data.length)}>
      {data.map((item: any, index: any) => {
        return <LayoutBgImage data={item} length={data.length} isLast={index === data.length - 1} />
      })}
    </Box>
  )
}

const styles = (breakpoint: number, responsivePadding: number) => {
  const isMobile = breakpoint < 600
  const isTab = breakpoint >= 600 && breakpoint <= 1024
  return {
    parentContainer: (length: number) =>
      ({
        display: 'flex',
        flexDirection: isTab ? 'column' : 'row',
        justifyContent: length === 2 ? 'flex-start' : 'space-between',
        paddingHorizontal: responsivePadding,
        paddingVertical: isMobile || isTab ? 20 : 120,
        pt: 40,
        flexWrap: isIE() ? 'nowrap' : 'wrap',
        bg: 'WHITE',
      } as BoxProps),
    container: (length: number) =>
      ({
        // height: length === 2 ? 336 : 528,
        minWidth: length === 2 ? (isMobile ? 320 : 536) : isMobile ? 288 : 320,
        maxWidth: isMobile || isTab ? '100%' : '33%',
        // marginRight: length === 2 ? 32 : 20,
        marginBottom: isMobile || isTab ? 0 : 120,
        paddingVertical: isTab ? 22 : isMobile ? 26 : 40,
        paddingHorizontal: isMobile || isTab ? 0 : 40,
        flexDirection: isTab ? 'row' : 'column',
      } as BoxProps),
  }
}
